// Function to update the cart
export const Address_ToDB = (address) => {
    if (typeof window !== 'undefined' && window.localStorage) {
        try {
            // Update the cart by storing the new cart data
            localStorage.setItem('address', JSON.stringify(address));
            console.log("STORED ",address )

            return true;
        } catch (error) {
            console.error('Error updating address:', error);
            return false;
        }
    } else {
        console.warn('localStorage is not available');
        return false;
    }
};

// Function to fetch the cart
export const Address_FromDB = () => {
    if (typeof window !== 'undefined' && window.localStorage) {
        try {
            const addressData = localStorage.getItem('address');
            console.log("LOADED ",addressData )
            // Return parsed cart if exists, otherwise return null
            return addressData ? JSON.parse(addressData) : null;
        } catch (error) {
            console.error('Error fetching cart:', error);
            return null;
        }
    }
    return null;
};